import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import { RootState } from '../../../../store';
import { setOtherCourierService } from '../../../../store/actions/inPatientAction';
import { courierProviders } from '../../../../shared/constants/commonConstants';
import { customGTMEvent } from '../service/crmUtils';
import { debounce } from 'lodash';

const TrackCourierModal = (props: any): ReactElement => {
  const {
    isShowTrackCourierModal,
    setIsShowTrackCourierModal,
    trackCourierForm,
    trackCourierFormSubmitHandler,
  } = props;
  const { Option } = Select;
  const { otherCourierOptionService } = useSelector((state: RootState): any => state?.selectedInPatientDetail);
  const dispatch = useDispatch();
  useEffect((): void => {
    dispatch(setOtherCourierService(''));
  }, [ isShowTrackCourierModal]);

  const debouncedInputChange = debounce(
    (label: string): void => {
      customGTMEvent({
        event: `Enter ${label}`,
      });
    }, 500,
  );

  return (
    <Modal
      title={'Track courier'}
      visible={isShowTrackCourierModal}
      onCancel={(): void => setIsShowTrackCourierModal(false)}
      footer={false}
      width="777px"
    >
      <p>Please upload your courier details to track the courier for selected claims only</p>

      <Form
        form={trackCourierForm}
        onFinish={trackCourierFormSubmitHandler}
        requiredMark="optional"
        layout="vertical"
      >
        <Row gutter={GUTTOR_SPACE}>
          <Col md={12}>
            <Form.Item
              name="courierProvider"
              label="Courier provider"
              rules={[
                {
                  required: true,
                  message: 'Please select courier provider!',
                },
              ]}
            >
              <Select placeholder="Select courier provider" onChange={(value: string): any => {
                customGTMEvent({
                  event: 'Select Courier Provider',
                  courierProvider: value,
                });
                dispatch(setOtherCourierService(value));
                }}>
                {
                  courierProviders.map((provider: any, index: number): any =>
                  <Option value={provider} key={index}>{provider}</Option>)
                }
              </Select>
            </Form.Item>
          </Col>
          {otherCourierOptionService === 'Hand Delivery' ?
          <Col md={12}>
            <Form.Item
              name="courierReceiptNumber"
              label="Receipt Number"
              rules={[
                {
                  required: true,
                  message: 'Please enter receipt number!',
                },
              ]}
            >
              <Input
                placeholder={'Enter courier receipt number'}
                onChange= {(): any => debouncedInputChange('Courier Receipt Number')}
              />
            </Form.Item>
          </Col> :
          <Col md={12}>
            <Form.Item
              name="courierTrackId"
              label="Courier Tracking/Acknowledgement Number"
              rules={[
                {
                  required: true,
                  message: 'Please enter courier tracking ID!',
                },
              ]}
            >
              <Input
                placeholder={'Enter courier tracking ID'}
                onChange= {(): any => debouncedInputChange('Courier Tracking/Acknowledgement Number')}
              />
            </Form.Item>
          </Col> }
          {otherCourierOptionService === 'Others' &&
            <Col md={12}>
              <Form.Item
                name="otherCourierProvider"
                label="Other Service Provider"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the other service provider',
                  },
                ]}
              >
                <Input placeholder={'Enter the other courier service provider'} />
              </Form.Item>
            </Col>

          }
          <Col md={24} className="text-center">
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TrackCourierModal;
